$(document).ready(function() {

    /* globale Variablen */

    var $form = $('#ttgTdVeranstaltungen form');
    var $resultContainer = $('#ttg_eventResults');
    var $loading = $resultContainer.find('.loading');
    var $nothingFound = $resultContainer.find('.nothingFound');
    var limit = parseInt($form.find('input[name="limit"]').val());
    var $masonry;
    var masonryActive = false;
    var $loadMore = $resultContainer.find('.loadMore');
    var $loadMoreWrapper = $loadMore.parent();
    var infiniteScrolling = $loadMoreWrapper.hasClass('infinite');
    var reloadFirstLi;

    /* Helper */

    var activeListStyle = function() {

        var listStyle = $('#ttg_displayOptions ul .active').data('liststyle');
        $('#ttg_eventResults').addClass(listStyle);

        return listStyle;

    };

    var isBreakpoint = function(alias) {

        return $('.device-' + alias).is(':visible');

    };





    /* Befülle Formular und qParam Handling */

    var getFormOptions = function() {
        getRegions();
        getCities();
        // getCategories();
    };

    var getRegions = function() {

        var $select = $form.find('#qString_area');
        if ($select.length) {
            $.ajax({
                method: 'POST',
                url: window.location.protocol + "//" + window.location.host + "/?type=1830",
                data: {
                    experience: $form.find('input[name="experience"]').val(),
                    type: 'Area',
                    template: $form.find('input[name="template"]').val(),
                    sort: 'title asc',
                    mkt: $form.find('input[name="mkt"]').val()
                },
                dataType: 'jsonp',
                beforeSend: function() {
                    $select.empty().append('<option value="">' + $select.attr('placeholder') + '</option>');
                },
                success: function(response) {
                    $.each(response.items, function(i, category) {
                        var $option = $('<option />');
                        $option.text(category.title);
                        $select.append($option);
                    });
                }
            });
        }

    };

    var getCities = function(area) {

        var $select = $form.find('#qString_city');
        if ($select.length) {
            $.ajax({
                method: 'POST',
                url: window.location.protocol + "//" + window.location.host + "/?type=1830",
                data: {
                    experience: $form.find('input[name="experience"]').val(),
                    type: 'City',
                    template: $form.find('input[name="template"]').val(),
                    q: (area) ? 'area:"' + area + '"' : '',
                    sort: 'title asc',
                    mkt: $form.find('input[name="mkt"]').val()
                },
                dataType: 'jsonp',
                beforeSend: function() {
                    $select.empty().append('<option value="">' + $select.attr('placeholder') + '</option>');
                },
                success: function(response) {
                    $.each(response.items, function(i, city) {
                        var $option = $('<option />');
                        $option.text(city.title);
                        $.each(city.attributes, function(i, attr) {
                            if (attr.key === 'GEMKZF') {
                                // console.log(attr.value);
                                $option.attr('value', attr.value);
                            }
                        });
                        $select.append($option);
                    });
                }
            });
        }

    };

    var getCategories = function() {

        var $select = $form.find('#qString_category');
        if ($select.length) {
            // Facetten aus META-Call
            // $.ajax({
            //   method: 'POST',
            //   url: 'https://meta.tourdata.at/rest.ashx/search/',
            //   data: {
            //     experience: $form.find('input[name="experience"]').val(),
            //     type: 'Event',
            //     template: $form.find('input[name="template"]').val(),
            //     facets: true,
            //     limit: 1,
            //     sort: 'title asc',
            //     mkt: $form.find('input[name="mkt"]').val()
            //   },
            //   dataType: 'jsonp',
            //   beforeSend: function(){
            //     $select.empty();
            //     // .append('<option value="">'+ $select.attr('placeholder') +'</option>');
            //   },
            //   success: function( response ){
            //     $.each(response.facetGroups, function( i, facetGroup ){
            //       if( facetGroup.field === 'category' ){
            //         var facets = facetGroup.facets.sort(function(a,b) {return (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0);} ); // inkl. Sorting
            //         $.each(facets, function( i, facet ){
            //           var $option = $('<option />');
            //           $option.prop('value',facet.value).text(facet.label);
            //           $select.append($option);
            //         });
            //       }
            //     });
            //     $select.chosen({
            //       no_results_text: $select.data('lang-nocategoryfoundfor'),
            //       width: '100%',
            //       search_contains: true,
            //       display_selected_options: false
            //       // include_group_label_in_selected: true,
            //       // hide_results_on_select: true
            //     });
            //   }
            // });

            // Select aus HTML mit Chosen bearbeiten
            $select.chosen({
                no_results_text: $select.data('lang-nocategoryfoundfor'),
                width: '100%',
                search_contains: true,
                display_selected_options: false,
                max_selected_options: 30
                // include_group_label_in_selected: true
                // hide_results_on_select: true
            });

        }

    };

    var qParamGenerator = function() {

        var qParams = [];
        var tourdataIds = [];
        var categories = [];

        // nur wenn KEINE TOURDATA Ids eingegeben wurden, dürfen die anderen Filter ziehen
        if ($form.find('input[name="q"]').data('filtertourdataids') == "") {
            if ($form.find('#qString_title').length > 0 && $form.find('#qString_title').val() !== '') {
                qParams.push($form.find('#qString_title').val());
            }
            if (($form.find('#qString_area').length && $form.find('#qString_area').val() !== '') &&
                ($form.find('#qString_city').length && $form.find('#qString_city').val() == '')
            ) {
                qParams.push('area:"' + $form.find('#qString_area').val() + '"');
            }
            if ($form.find('#qString_city').length && $form.find('#qString_city').val() !== '') {
                qParams.push('area:"' + $form.find('#qString_city').val() + '"');
            }
            if ($form.find('#qString_category').length && $("#qString_category input:checkbox:checked").length > 0) {
                $.each($("#qString_category input:checkbox:checked"), function() {
                    categories.push($(this).val());
                });
                qParams.push('category:("' + categories.join('" OR "') + '")');
            }
            // Vorfilter Handling
            if ($form.find('#qString_category_preFiltering').length && $("#qString_category input:checkbox:checked").length == 0) {
                qParams.push('category:("' + $form.find('#qString_category_preFiltering').val().join('" OR "') + '")');
            }
            // if( $form.find('#qString_sorting').val()  !== '' ){ qParams.push( 'sorting:'+ $form.find('#qString_sorting').val() +'"' )  }
            if ($form.find('input[name="q"]').data('dataquality') != "") {
                qParams.push('rating_DataQuality:[' + $form.find('input[name="q"]').data('dataquality') + ' TO 100]');
            }
            if ($form.find('input[name="q"]').data('filtertop') != "") {
                qParams.push('keyword:("' + $form.find('input[name="q"]').data('filtertop') + '")');
            }
            if ($form.find('input[name="q"]').data('query') != "") {
                qParams.push($form.find('input[name="q"]').data('query'));
            }
        }

        // TOURDATA IDs auswerten
        if ($form.find('input[name="q"]').data('filtertourdataids') != "") {
            var tmp = $form.find('input[name="q"]').data('filtertourdataids').toString();
            var checkComma = tmp.indexOf(",");
            if (checkComma > 0) {
                tourdataIds = tmp.split(',');
                qParams.push('sourceid:(' + tourdataIds.join(' OR ') + ')');
            } else {
                if (tmp.length > 0) {
                    qParams.push('sourceid:(' + tmp + ')');
                }
            }
        }

        console.log(qParams);

        $form.find('input[name="q"]').val(qParams.join(" AND "));

    };

    getFormOptions();

    $form.find('#qString_area').change(function(e) {
        var selectedVal = $(this).find('option:selected').val();
        getCities(selectedVal);
    });

    var now = new Date();
    var currentDate = moment();

    var datePickers = document.querySelectorAll('.datepicker');

    datePickers.forEach(function(dp) {
        var inputNode = dp.querySelector('input');
        var buttonNode = dp.querySelector('button');
        var dialogNode = dp.querySelector('[role=dialog]');

        var datePicker = new DatePicker(inputNode, buttonNode, dialogNode);
        datePicker.init();
        datePicker.setTextboxDate(now);
    });

    /* Lade Events & verarbeite Response */

    var loadEvents = function(e, mode) {

        if (e.type && (e.type === 'click' || e.type === 'submit')) {
            e.preventDefault();
        }

        // Enddate Befüllung sofern Relevanzsortierung
        if ($form.find('#sort').val() === "rating_Relevanz_41 desc, title asc") {
            $('#enddate').val($('#qString_bis').val());
        } else {
            if ($('#enddate').val().length === 0) {
                $('#enddate').val('3000-12-31');
            }
        }

        var layoutTimeout = (activeListStyle() === 'kacheln') ? 500 : 0; // Timeout benötigt für Rendering

        $.ajax({
            method: 'POST',
            url: window.location.protocol + "//" + window.location.host + "/?type=1830",
            data: $form.serialize(),
            dataType: 'jsonp',
            beforeSend: function() {

                $loading.fadeIn();
                $loadMore.hide();
                $loadMoreWrapper.addClass('loading');
                $resultContainer.addClass('picLoadingIndication');
                $nothingFound.hide();

                if (mode === 'reset') {
                    $resultContainer.find('ul').fadeOut(400);
                    $resultContainer.find('ul').remove();
                    masonryActive = false;
                }

            },
            success: function(response) {

                if (response.overallcount > 0) {

                    var $result = resultHtml(response); // HTML ohne Listen-/Kachelklassen
                    var $resultWithListstylesUl = createColClasses($result, mode);
                    var $resultWithListstylesLi = $resultWithListstylesUl.find('li');

                    switch (mode) {

                        default:
                        case 'reset':

                            $resultContainer.prepend($resultWithListstylesUl);
                            break;

                        case 'append':

                            $resultContainer.find('ul').append($resultWithListstylesLi);

                            if (activeListStyle() === 'kacheln' && !isBreakpoint('xs') && !isBreakpoint('sm')) {

                                setTimeout(function(e) {
                                    $masonry.masonry('appended', $resultWithListstylesLi);
                                }, layoutTimeout);

                            }

                            break;

                    }

                }

            },
            complete: function(jqXHR) {

                if (infiniteScrolling) {
                    $loadMoreWrapper.addClass('active');
                }

                if (mode === 'reset' || activeListStyle() === 'liste') {
                    $resultContainer.find('li').addClass('visible');
                }

                if (activeListStyle() === 'liste' || (isBreakpoint('xs') || isBreakpoint('sm'))) {
                    $loading.fadeOut();
                    $resultContainer.removeClass('picLoadingIndication');
                }

                if (activeListStyle() === 'kacheln') {

                    setTimeout(function(e) {
                        $resultContainer.find('li').addClass('visible');
                        if (mode === 'reset') {
                            createMasonry();
                        }
                        $loading.fadeOut();
                    }, layoutTimeout);

                    fixMasonryLayout();

                }

                setTimeout(function(e) {

                    if ($resultContainer.find('li:not(.clearfix)').length < jqXHR.responseJSON.overallcount) {
                        $loadMore.fadeIn();
                    }

                    if (jqXHR.responseJSON.overallcount < 1) {
                        $resultContainer.find('.nothingFound').fadeIn();
                    }

                    $loadMoreWrapper.removeClass('loading');

                    if ($('input[name="offset"]').val() != 0) {
                        $(".boxHolder" + reloadFirstLi)[$('input[name="offset"]').val()].focus();
                    }

                }, layoutTimeout);

                reloadFirstLi = '';
            }
        });

    };

    var fixMasonryLayout = function() { // Erzeugt das Masonry Layout nach einer fixen Zeitspanne nochmals "neu" (falls Bilder länger geladen wurden und dadurch Positionierungsfehler auftreten, werden Diese dadurch behoben - hat schon alles gepasst merkt der User Nichts davon)
        if (!isBreakpoint('xs') && !isBreakpoint('sm')) {

            setTimeout(function(e) {
                $masonry.masonry('layout');
                $resultContainer.removeClass('picLoadingIndication');
            }, 2500);

        }

    };

    var resultHtml = function(response) {

        var date = new Date();
        var fancyDate = function(zahl) {
            var fancyDate = (parseInt(zahl) < 10) ? '0' + zahl : zahl;
            return fancyDate;
        };

        var $ul = $('<ul class="row"></ul>');

        $.each(response.items, function(i, event) {

            var fixtureCount, venueCount, nextStart, nextEnd, lastStart;
            $.each(event.attributes, function(i, attribute) {
                switch (attribute.key) {
                    case 'FixtureCount':
                        fixtureCount = parseInt(attribute.value);
                        break;
                    case 'VenueCount':
                        venueCount = parseInt(attribute.value);
                        break;
                    case 'interval_first_match_start':
                        nextStart = new Date(attribute.value + ':00');
                        break;
                    case 'interval_first_match_end':
                        nextEnd = new Date(attribute.value + ':00');
                        break;
                    case 'LastFixtureStart':
                        lastStart = new Date(attribute.value + ':00');
                        break;
                }
            });
            var actual = (date >= nextStart) ? true : false;

            var $li = $('<li class="event"></li>');

            if (!reloadFirstLi) {
                reloadFirstLi = event.id;
            }

            $.each(event.keywords, function(i, keyword) {
                if (keyword === 'Top (Region)' && $resultContainer.data('top-region') == "1") {
                    $li.addClass('highlight');
                }
                if (keyword === 'Top (Bundesland)' && $resultContainer.data('top-bundesland') == "1") {
                    $li.addClass('highlight');
                }
                if (keyword === 'Top (Markendestination)' && $resultContainer.data('top-markendestination') == "1") {
                    $li.addClass('highlight');
                }
            });

            var $boxHolder = $('<a href="" class="boxHolder boxHolder' + event.id + '"></a>');

            var img = false;
            var titleCopyright = "";
            var copyright = "";
            var open = $resultContainer.data('copyright-open');
            var close = $resultContainer.data('copyright-close');

            $.each(event.media_objects, function(i, mObject) {
                if (mObject.rel === 'default') {
                    img = mObject.url;
                    alt = mObject.value;
                    if (mObject.source) {
                        titleCopyright = alt + " (&copy; " + mObject.source + ")";
                        copyright = "&copy; " + mObject.source;
                    }
                }

            });

            var $img = $('<span class="pic"><img src="//cdn.ttg.at/fileadmin/templates/global/images/rebrush/dummy_pics/veranstaltung_dummy.jpg" alt="" class="default" aria-hidden="true"></span>');
            if (img) {
                $img = $('<div class="pic ttgNCEBildSingle">');
                if (copyright && $resultContainer.data('show-copyright')) {
                    $img.append($('<div class="ttgCopyright"><button class="ttgCopyrightIcon">&copy;<span class="sr-only">' + open + '</span></button><div class="ttgCopyrightText">' + copyright + '<button class="ttgCopyrightTextButton"><span class="fas fa-times" aria-hidden="true"></span><span class="sr-only">' + close + '</span></button></div></div>'));
                }
                $img.append($('<img src="' + img.replace('/original/', '/ltoDetailpic/') + '" alt="' + alt + '" title="' + titleCopyright + '" aria-hidden="true"></div>'));
            }
            $boxHolder.append($img);


            var $contentHolder = $('<div class="contentHolder"></div>');


            var $h3 = $('<h3><span>' + event.title + '</span></h3>');
            $contentHolder.append($h3);


            var $dateTime = $('<p class="dateTime"></p>');

            var $dateString = $('<strong><span class="date" /></strong>');

            // > JETZT
            //
            //   > ENDE HEUTE || "Jetzt, bis 18:00"
            //     > GANZTÄGIG || "Jetzt, ganztägig"
            //   > ENDET ZUKUNFT || "Jetzt, bis 15.03.2018 - 18:00"
            //     > GANZTÄGIG TOURDATA FIX || "Jetzt, ganztägig" // = ENDE HEUTE GANZTÄGIG
            //
            // > ZUKUNFT
            //
            //   > HEUTE || "Heute, 18:00"
            //   > ZUKUNFT || "15.03.2018 - 18:00"

            var nowMonth = date.getMonth() + 1;
            var nowString_date = date.getDate() + '.' + nowMonth + '.' + date.getFullYear();

            var nextStartMonth = nextStart.getMonth() + 1;
            var nextStartString_date = $resultContainer.data('day' + nextStart.getDay()) + ", " + nextStart.getDate() + '.' + nextStartMonth + '.' + nextStart.getFullYear();
            var nextStartString_time = fancyDate(nextStart.getHours()) + ':' + fancyDate(nextStart.getMinutes());

            var dateInBox = new Date(nextStart.getFullYear(), nextStart.getMonth(), nextStart.getDate()); // 2009-11-10
            var lang = $('html').attr('lang').substr(0, 2);
            var month = dateInBox.toLocaleString(lang, {
                month: 'short'
            });
            var day = ("0" + nextStart.getDate()).slice(-2);

            $dateInBox = "<div class='dateBox'><p><strong>" + day + "</strong></p><p>" + month + "</p></div>";
            $boxHolder.append($dateInBox);

            var nextEndMonth = nextEnd.getMonth() + 1;
            var nextEndString_date = nextEnd.getDate() + '.' + nextEndMonth + '.' + nextEnd.getFullYear();
            var nextEndString_time = fancyDate(nextEnd.getHours()) + ':' + fancyDate(nextEnd.getMinutes());

            // JETZT > Event hat bereits begonnen
            if (actual) {

                // $dateString.text( $resultContainer.data('lang-jetzt')+', ' );
                $dateString.text($resultContainer.data('lang-heute') + ', ');
                // $dateString.text( 'Jetzt, ' );

                // JETZT & ENDET HEUTE
                if (nowString_date === nextEndString_date) {

                    // JETZT & GANZTÄGIG > startet um 00:00 & endet Mitternacht
                    if (nextStartString_time === '00:00' && nextEndString_time === '23:59') {

                        $dateString.append($resultContainer.data('lang-ganztaegig'));

                    }

                    // JETZT & NICHT GANZTÄGIG > endet vor Mitternacht
                    else {

                        $dateString.append($resultContainer.data('lang-bis') + ' ' + nextEndString_time);

                    }

                }

                // JETZT & ENDET NICHT HEUTE
                else {

                    if (nextStartString_time === '00:00' && nextEndString_time === '00:00') { // fix für Tourdata ganztägig Ausgabe (=endet am selben Tag 23:59)

                        $dateString.append($resultContainer.data('lang-ganztaegig'));

                    } else {

                        $dateString.append($resultContainer.data('lang-bis') + ' ' + nextEndString_date + ' - ' + nextEndString_time);

                    }

                }

            }

            // ZUKÜNFTIGES EVENT
            else {

                // STARTET NOCH HEUTE
                if (nowString_date === nextStartString_date) {

                    $dateString.text($resultContainer.data('lang-heute') + ', ');
                    $dateString.append(nextStartString_time);

                }

                // STARTET NICHT MEHR HEUTE
                else {

                    $dateString.append(nextStartString_date + ' - ' + nextStartString_time);

                }

            }

            $dateTime.append($dateString);

            if (fixtureCount > 1) { // weitere Termine Link

                $dateTime.append('<span class="weitere"><span class="weitereTermine">&raquo; ' + $resultContainer.data('lang-weitere') + '</span></span>');

            }

            $contentHolder.append($dateTime);


            var $locationCity = $('<p class="locationCity"></p>');

            $.each(event.texts, function(i, text) { // Veranstaltungsort(e)
                if (text.rel === 'venues') {
                    $locationCity.append($('<span class="location">' + text.value + '</span>'));
                }
            });
            if (venueCount <= 1) { // Zeige Ortsinformation nur wenn nur 1 Ort
                $locationCity.append($('<span class="city">' + event.zip + ' ' + event.city + '</span>'));
            }

            $contentHolder.append($locationCity);


            $boxHolder.append($contentHolder);

            // Link kann erst hier asynchron geladen werden, da der $boxHolder erst hier im DOM zur Verfügung steht
            var link = getDetailLink(event);

            $li.append($boxHolder);

            $ul.append($li);

        });

        return $ul;

    };

    var getDetailLink = function(event) {

        var title = slugify(event.title);

        $.ajax({
            type: "POST",
            url: "/?type=7777",
            data: "pageUid=" + $form.find('input[name="q"]').data('pageuid') + "&tourdataId=" + event.id + "&tourdataTitle=" + title + "&sysLanguageUid=" + $('#ttg_eventResults').data('syslanguageuid'),
            beforeSend: function() {},
            success: function(result) {},
            complete: function(result) {
                $(".boxHolder" + event.id).attr("href", result.responseText);
            },
            error: function() {
                //alert("error");
            }
        });

    };

    var slugify = function(text) {

        return text.toString().toLowerCase()
            .replace(/\s+/g, '-') // Replace spaces with -
            .replace(/[^\w\-]+/g, '') // Remove all non-word chars
            .replace(/\-\-+/g, '-') // Replace multiple - with single -
            .replace(/^-+/, '') // Trim - from start of text
            .replace(/-+$/, ''); // Trim - from end of text

    };

    var createMasonry = function() {

        if (!isBreakpoint('xs') && !isBreakpoint('sm')) {

            $masonry = $resultContainer.find('ul').masonry({
                itemSelector: 'li'
            });
            masonryActive = true;

        }

    };

    var resetClasses = function($ul, mode) {

        if (masonryActive && mode === 'reset') {
            $masonry.masonry('destroy');
            masonryActive = false;
        }
        $ul.find('li').removeClass('col-md-3 col-md-4 col-md-5 col-md-6 col-md-offset-2');
        $ul.find('li.clearfix').remove();
        $ul.find('.row').removeClass('row'); // !!! ev. Ebene höher
        $ul.find('.col-xs-3').removeClass('col-xs-3');
        $ul.find('.col-xs-9').removeClass('col-xs-9');
        $ul.find('.col-xs-12').removeClass('col-xs-12');

    };

    var createColClasses = function($ul, mode) {

        resetClasses($ul, mode);

        var $li = $ul.find('li');
        var colsClass;

        if (activeListStyle() === 'kacheln') {

            colsClass = 'col-md-' + $resultContainer.data('kachelcols');

        } else {

            colsClass = 'col-md-' + $resultContainer.data('liststyle');

            // Clearfix & padding in Liste
            var $clearfix = $('<li />').addClass('clearfix');
            $ul.find('li:odd').each(function(e) {
                $clearfix.clone().insertAfter($(this));
                if (colsClass == 'col-md-5') {
                    $(this).addClass('col-md-offset-2');
                }
            });

            $li.find('.boxHolder').addClass('row').each(function(e) {
                $(this).find('.pic').addClass('col-xs-3');
                if ($(this).find('.col-xs-3').length) {
                    $(this).find('.contentHolder').addClass('col-xs-9');
                } else {
                    $(this).find('.contentHolder').addClass('col-xs-12');
                }
            });

        }

        $li.addClass(colsClass);

        return $ul;

    };

    /* Actions */

    if (isBreakpoint('xs') || isBreakpoint('sm')) {

        $('#ttgTdVeranstaltungen').addClass('mobileMode');

        // On mobile - automatic Kachelmode
        // RESET
        $('#ttg_displayOptions').find('ul').find('li a').removeClass('active');

        // ACTIVE LAYOUT
        $('#ttg_displayOptions').find('ul').find('a[data-liststyle="kacheln"]').addClass('active');
        $resultContainer.removeClass('kacheln').removeClass('liste').addClass(activeListStyle());
        var resultWithListstylesUl = createColClasses($resultContainer.find('ul'), 'reset');

    }

    $form.submit(function(e) {
        $loadMore.hide();
        $('input[name="offset"], input[name="actualCount"]').val(0);
        qParamGenerator();
        loadEvents(e, 'reset');
    });

    var loadMore = function(e) {
        $('input[name="offset"]').val(parseInt($('input[name="offset"]').val()) + limit);
        loadEvents(e, 'append');
    };

    // load More nach Click
    $loadMore.click(loadMore);

    // Buttons Filteroptionen
    $(".searchButtons button").click(function() {
        if (!$(this).hasClass("active")) {
            $(".searchButtons button.active").removeClass('active');
            $(this).addClass('active');
            $(this).attr("aria-pressed", true);
            var startdate;
            var enddate;
            var nextDay = moment();
            var plusSevenDays = moment();
            nextDay.add(1, 'days');
            plusSevenDays.add(7, 'days');
            startdate = currentDate.year() + "-" + currentDate.format('MM') + "-" + currentDate.format('DD');

            if ($(this).val() == 'heute') {
                enddate = currentDate.year() + "-" + currentDate.format('MM') + "-" + nextDay.format('DD');
                // alert(startdate + " - " + enddate);
            } else if ($(this).val() == '7days') {
                enddate = plusSevenDays.year() + "-" + plusSevenDays.format('MM') + "-" + plusSevenDays.format('DD');
            } else if ($(this).val() == 'thisMonth') {
                startdate = currentDate.startOf('month').format('YYYY-MM-DD');
                enddate = currentDate.endOf('month').format('YYYY-MM-DD');
            }

            $('input[name="startdate"]').val(startdate);
            $('#enddate').val(enddate);
            $form.submit();
        } else {
            $(this).removeClass('active');
            $(this).attr("aria-pressed", false);
            var parts = $form.find('#qString_ab').val().split('.');
            var theDate = parts[2] + "-" + ('0' + parts[1]).slice(-2) + "-" + ('0' + parts[0]).slice(-2);
            $('input[name="startdate"]').val(theDate);
            $('#enddate').val('3000-12-31');
            $form.submit();
        }
    });

    // Load More Infinite
    if (infiniteScrolling) {
        var scrollMagicCtrl = new ScrollMagic.Controller();
        var scene = new ScrollMagic.Scene({
            triggerElement: '.loadMoreWrapper.infinite',
            offset: -350
        })
            .addTo(scrollMagicCtrl)
            .on('enter', function(e) {
                // console.log( $loadMore.is(':visible') );
                if (!$loadMoreWrapper.hasClass('active')) {
                    $form.submit(); // initiales Laden von Events bei aktiviertem Infinite Scrolling
                } else {
                    if (!$loadMoreWrapper.hasClass('loading') && $loadMore.is(':visible')) {
                        loadMore(e);
                    }
                }
            });
    } else {
        if (!$loadMoreWrapper.hasClass('active')) {
            $form.submit(); // initiales Laden von Events bei aktiviertem Infinite Scrolling
        } else {
            if (!$loadMoreWrapper.hasClass('loading') && $loadMore.is(':visible')) {
                loadMore(e);
            }
        }
    }

    $form.find('#sort').change(function() {
        $form.submit();
    });

    $('#ttg_displayOptions a').click(function(e) {

        e.preventDefault();
        var ul = $(this).closest('ul');

        // RESET
        ul.find('li a').removeClass('active');

        // ACTIVE LAYOUT
        $(this).addClass('active');
        $('#ttg_eventResults').removeClass('kacheln').removeClass('liste').addClass(activeListStyle());
        var resultWithListstylesUl = createColClasses($resultContainer.find('ul'), 'reset');

        if (activeListStyle() === 'kacheln') {
            createMasonry();
        }

    });

});



/* TODO

 (.) Lokalisierung
 (x) Kategorienfilter
 (x) Tourdata Ergebnisse
 (.) Template
 (x) DE
 (x) EN
 ( ) weitere Sprachen (NL, IT, CS, PL)
 (x) LinkURLs
 (x) Highlighting
 (x) Top Region, TOP Bundesland, TOP Markendestination > wartbar über Plugin Settings
 (x) Datum übergeben
 (x) Infinite Scrolling
 (x) Flexform Einstellungen
 (x) Detailverlinkung
 (x) über Pagepath & embed URL > ???
 (x) Nothing Found Handling
 (x) Sortierung
 (x) Optionen
 (x) Results
 (x) Datumsanzeigen (OOEAT-958 > bei Michael)
 (x) Filterung nach Orten (OOEAT-958 > bei Michael)
 (.) Sortierung
 ( ) Korrekt nach Datum (liegt bei Hary)
 (x) Korrekt nach Relevanz
 (x) Vorfilterung
 (x) Prolem mit max-length of GET-Params

 */